import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["orgId"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { AbortControllerFacade } from '../abort-controller';
import { requestWithAbort } from '../use-service';
import { TeamsPermissionApi } from './types';
export var urlGetPermissions = function urlGetPermissions(_ref) {
  var orgId = _ref.orgId,
    siteId = _ref.siteId,
    apiVersion = _ref.apiVersion;
  return "/gateway/api/".concat(apiVersion, "/teams/permission/self/organization/").concat(orgId).concat(apiVersion === 'v4' ? "?siteId=".concat(siteId) : '');
};
export var requestPermissions = function requestPermissions(_ref2) {
  var orgId = _ref2.orgId,
    props = _objectWithoutProperties(_ref2, _excluded);
  return orgId ? requestWithAbort(urlGetPermissions(_objectSpread(_objectSpread({}, props), {}, {
    orgId: orgId
  })), {
    method: 'GET'
  }) : [function () {
    return Promise.resolve();
  }, new AbortControllerFacade()];
};
export var transformPermissions = function transformPermissions(permissions) {
  return permissions.reduce(function (acc, permission) {
    switch (permission) {
      case TeamsPermissionApi.canCreateTeams:
        return _objectSpread(_objectSpread({}, acc), {}, {
          canCreateTeams: true
        });
      case TeamsPermissionApi.canViewTeams:
        return _objectSpread(_objectSpread({}, acc), {}, {
          canViewTeams: true
        });
      case TeamsPermissionApi.canAdminTeams:
        return _objectSpread(_objectSpread({}, acc), {}, {
          canAdminTeams: true
        });
      default:
        return acc;
    }
  }, {
    canCreateTeams: false,
    canViewTeams: false,
    canAdminTeams: false
  });
};